/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn, Item } from '../../registry/Component.type';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './TransactionMapping';

const TransactionMappingManager: ComponentManagerFn<'TransactionMapping'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'TransactionMapping'>(
      platform,
      'TransactionMapping',
    ),
    type: 'TransactionMapping',
    name: 'Transaction Mapping',
    defaultValue,
    props: {
      childAttribute: {
        aliasType: 'TRANSACTION',
        category: 'Data',
        getAttributeDataTypes: () => [
          'Decimal',
          'Double',
          'Integer',
          'String',
          'UserID',
        ],
        getAlias: (page, item, { pageId }) => {
          const childTxn = page[item.parent] as Item<'Transaction'>;
          return {
            alias: childTxn.props.alias,
            embeddedPageId: pageId,
          };
        },
        label: 'Child Attribute',
        required: true,
        type: 'ViewAttributeChooser',
      },
      parentAttribute: {
        aliasType: 'TRANSACTION',
        category: 'Data',
        getAttributeDataTypes: () => [
          'Decimal',
          'Double',
          'Integer',
          'String',
          'UserID',
        ],
        getAlias: (page, item, { pageId }) => {
          const childTxn = page[item.parent] as Item<'Transaction'>;
          const parentTxn = page[childTxn.parent] as Item<'Transaction'>;
          return {
            alias: parentTxn.props.alias,
            embeddedPageId: pageId,
          };
        },
        label: 'Parent Attribute',
        preventMultiEdit: true,
        type: 'ViewAttributeChooser',
        required: true,
      },
      excludeFromFilter: {
        category: 'Data',
        label: 'Exclude from Filter',
        type: 'boolean',
        helpText: `If checked, this attribute will not be added to the where clause when querying the child store.

Use this option if you want to use this mapping just for copying the value from parent to child row on creation.`,
      },
    },
    getDisplayText: (item) =>
      `${item.props.childAttribute} - ${item.props.parentAttribute}`,
    category: 'Data',
    icon: { iconName: 'arrows-h' },
    description: 'It is used to specify transaction mapping for a transaction.',
  };
};

export default TransactionMappingManager;
